import { render } from "./multiple.vue?vue&type=template&id=1bd26f5b&scoped=true"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"

import "./multiple.vue?vue&type=style&index=0&id=1bd26f5b&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd26f5b"]])

export default __exports__